import { render, staticRenderFns } from "./createWxOrderUsa.vue?vue&type=template&id=6c2e972c&scoped=true"
import script from "./createWxOrderUsa.vue?vue&type=script&lang=js"
export * from "./createWxOrderUsa.vue?vue&type=script&lang=js"
import style0 from "./createWxOrderUsa.vue?vue&type=style&index=0&id=6c2e972c&prod&scoped=true&lang=css"
import style1 from "./createWxOrderUsa.vue?vue&type=style&index=1&id=6c2e972c&prod&lang=css"
import style2 from "./createWxOrderUsa.vue?vue&type=style&index=2&id=6c2e972c&prod&scoped=true&lang=scss"
import style3 from "./createWxOrderUsa.vue?vue&type=style&index=3&id=6c2e972c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e972c",
  null
  
)

export default component.exports